import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  JhaPubSubService,
  JhaPubSubMessage,
} from "@jkhy/responsive-ui-angular/jha-responsive-core";
import { PFrameRoutes } from "../../shared/pframe-routes";
import { DataService } from "../../services/data.service";

@Component({
  selector: "login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  public showPassword = false;
  public customerName: string;
  public copyrightNotice: string;
  public invalidLogin: boolean;
  public userId: string;
  public password: string;
  public loggingIn: boolean;
  public isForcedLogout = false;
  public isInactivityLogout = false;

  constructor(
    private dataService: DataService,
    private router: Router,
    private pubSubService: JhaPubSubService
  ) {
    this.copyrightNotice = "Copyright &copy; Jack Henry & Associates, Inc.";
    this.invalidLogin = false;
    this.userId = "";
    this.password = "";
    this.loggingIn = false;

    this.isForcedLogout = this.dataService.IsForcedLoggedOut();
    this.isInactivityLogout = this.dataService.IsLoggedOutForInactivity();
  }

  ngOnInit(): void {
    // Set focus to username. The input control has autofocus turned on, but
    // that doesn't seem to work when using ui-router to navigate to views.
    window.setTimeout(() => {
      document.getElementById("inputUser").focus();
    }, 500);
  }

  toggleShowPassword(): void {
    this.showPassword = !this.showPassword;
    window.setTimeout(() => {
      document.getElementById("showPasswordBtn").blur();
    }, 50);
  }

  logOn(): void {
    this.loggingIn = true;
    this.dataService
      .LogIn(this.userId, this.password)
      .subscribe((data) => this.processLogin(data));
  }

  private processLogin(loginResult: any): void {
    this.invalidLogin = !loginResult;
    if (loginResult.status === "S") {
      this.pubSubService.Stream.next(new JhaPubSubMessage("LoggedIn", null));
      this.pubSubService.Stream.next(
        new JhaPubSubMessage("SessionId", loginResult.sessionId)
      );
      this.pubSubService.Stream.next(
        new JhaPubSubMessage("ConnectionId", loginResult.connectionId)
      );
      this.pubSubService.Stream.next(
        new JhaPubSubMessage("UserProfile", loginResult.userProfile)
      );
      this.router.navigate([PFrameRoutes.home]);
    } else {
      this.invalidLogin = true;
    }
    this.loggingIn = false;
  }

  navigateToForgotPassword() {
    return this.router.navigate([PFrameRoutes.forgotPassword]);
  }
}
